import { MouseEvent } from 'react';
import styles from './PatientListItemDetails.module.scss';
import cx from 'classnames';
import { Icon, Menu, RolePermissionChecker, Text } from 'components';
import { useDevice } from 'hooks';
import { dashboardActions } from 'store/dashboard/slice';
import { useDispatch } from 'store/utils';
import { UserRole } from 'types';

type Props = {
  patientCaseId: number;
};

export const PatientListItemDetails = ({ patientCaseId }: Props) => {
  const { isTablet } = useDevice();

  const dispatch = useDispatch();

  const onDismissPatientCase = async () => {
    try {
      await dispatch(dashboardActions.dismissPatientCase(patientCaseId)).unwrap();
    } catch {
      console.log('failed to dismiss ', patientCaseId);
    }
  };
  return (
    // <RolePermissionChecker rolesAllowedToView={[UserRole.CLINIC, UserRole.DOCTOR, UserRole.ADMIN, UserRole.READ_ONLY]}>
    //   {/* <Menu buttonContainerClassname={styles.buttonContainer}>
    //     <ul className={cx(styles.list, { [styles.isTouchScreen]: isTablet })}>
    //       <li className={styles.listOption} onClick={onDismissPatientCase}>
    //         <Icon name="Cross" className={styles.icon} />
    //         <Text type="body2">Dismiss message notification</Text>
    //       </li>
    //     </ul>
    //   </Menu> */}
    // </RolePermissionChecker>
    null
  );
};
